// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"d8537fa4","312":"363c07e0"}[chunkId] + ".chunk.css";
};